module.exports = __webpack_public_path__ + "static/media/gem1.0d306cfe.png";